import { UserSubscription } from '@creditsights/api-ui-web';
import intersection from 'lodash/intersection';
import { ContentTypeFilter } from '../../models';

export enum WIDGET_ID {
  ANNOUNCEMENTS = 'ANNOUNCEMENTS',
  MORNING_COMMENT = 'MORNING_COMMENT',
  TOP_READS = 'TOP_READS',
  RECENTLY_REC_CHANGES = 'RECENTLY_REC_CHANGES',
  RECENTLY_VIEWED = 'RECENTLY_VIEWED',
  CR_QUICK_FILTERS = 'CR_QUICK_FILTERS',
  CS_QUICK_LINKS = 'CS_QUICK_LINKS',
}

export const GLOBAL_ONLY_WIDGETS = [WIDGET_ID.CS_QUICK_LINKS];

const FEED_ORDER_BY_ENTITLEMENTS_CONFIG: Record<UserSubscription, WIDGET_ID[]> = {
  [UserSubscription.CS_CR_LFI]: [
    WIDGET_ID.CR_QUICK_FILTERS,
    WIDGET_ID.ANNOUNCEMENTS,
    WIDGET_ID.MORNING_COMMENT,
    WIDGET_ID.TOP_READS,
    WIDGET_ID.RECENTLY_REC_CHANGES,
    WIDGET_ID.CS_QUICK_LINKS,
    WIDGET_ID.RECENTLY_VIEWED,
  ],
  [UserSubscription.CS_CR]: [
    WIDGET_ID.CR_QUICK_FILTERS,
    WIDGET_ID.ANNOUNCEMENTS,
    WIDGET_ID.MORNING_COMMENT,
    WIDGET_ID.TOP_READS,
    WIDGET_ID.RECENTLY_REC_CHANGES,
    WIDGET_ID.CS_QUICK_LINKS,
    WIDGET_ID.RECENTLY_VIEWED,
  ],
  [UserSubscription.CS_LFI]: [
    WIDGET_ID.ANNOUNCEMENTS,
    WIDGET_ID.MORNING_COMMENT,
    WIDGET_ID.TOP_READS,
    WIDGET_ID.RECENTLY_REC_CHANGES,
    WIDGET_ID.CS_QUICK_LINKS,
    WIDGET_ID.RECENTLY_VIEWED,
  ],
  [UserSubscription.CR_LFI]: [WIDGET_ID.CR_QUICK_FILTERS, WIDGET_ID.TOP_READS, WIDGET_ID.RECENTLY_VIEWED],
  [UserSubscription.CS]: [
    WIDGET_ID.ANNOUNCEMENTS,
    WIDGET_ID.MORNING_COMMENT,
    WIDGET_ID.TOP_READS,
    WIDGET_ID.RECENTLY_REC_CHANGES,
    WIDGET_ID.CS_QUICK_LINKS,
    WIDGET_ID.RECENTLY_VIEWED,
  ],
  [UserSubscription.CR]: [WIDGET_ID.CR_QUICK_FILTERS, WIDGET_ID.TOP_READS, WIDGET_ID.RECENTLY_VIEWED],
  [UserSubscription.LFI]: [WIDGET_ID.TOP_READS, WIDGET_ID.RECENTLY_VIEWED],
};

const FEED_ORDER_BY_CONTENT_TYPE_CONFIG: Record<ContentTypeFilter, WIDGET_ID[]> = {
  [ContentTypeFilter.ALL]: [
    WIDGET_ID.ANNOUNCEMENTS,
    WIDGET_ID.MORNING_COMMENT,
    WIDGET_ID.TOP_READS,
    WIDGET_ID.RECENTLY_REC_CHANGES,
    WIDGET_ID.CS_QUICK_LINKS,
    WIDGET_ID.RECENTLY_VIEWED,
  ],
  [ContentTypeFilter.RESEARCH]: [
    WIDGET_ID.ANNOUNCEMENTS,
    WIDGET_ID.MORNING_COMMENT,
    WIDGET_ID.TOP_READS,
    WIDGET_ID.RECENTLY_REC_CHANGES,
    WIDGET_ID.CS_QUICK_LINKS,
    WIDGET_ID.RECENTLY_VIEWED,
  ],
  [ContentTypeFilter.COVENANTS]: [WIDGET_ID.RECENTLY_VIEWED, WIDGET_ID.CR_QUICK_FILTERS, WIDGET_ID.TOP_READS],
  [ContentTypeFilter.NEWS]: [WIDGET_ID.TOP_READS, WIDGET_ID.RECENTLY_VIEWED],
};

export const getFeedWidgets = (
  userSubscription: UserSubscription,
  articleTypeFilter: ContentTypeFilter
): WIDGET_ID[] => {
  const widgetsByEntitlements = FEED_ORDER_BY_ENTITLEMENTS_CONFIG[userSubscription];
  const widgetsByContentTab = FEED_ORDER_BY_CONTENT_TYPE_CONFIG[articleTypeFilter];
  return intersection(widgetsByEntitlements, widgetsByContentTab);
};

export const FEED_WIDGETS_KEY = 'FeedWidgets';
